import React, { useEffect, useState } from "react";
import { Row, Col, Form, Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { Search } from "lucide-react";

import "../../../../assets/css/my-Profile.css";
import Breadcrumbdasbord from "../../component/Breadcrumbdasbord";
import Sidebarmenu from "../../component/SidebarNavigation";
import { getCustomers } from "../../service/customerdata.service";

function CustomerPage() {
  const [customers, setCustomers] = useState([]);
  const [filteredCustomers, setFilteredCustomers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCustomers();
  }, []);

  const loadCustomers = async () => {
    try {
      setLoading(true);

      const res = await getCustomers();

      // API response handle
      const data = Array.isArray(res?.data)
        ? res.data
        : Array.isArray(res?.data?.data)
        ? res.data.data
        : Array.isArray(res)
        ? res
        : [];

      setCustomers(data);
      setFilteredCustomers(data);
    } catch (error) {
      console.error("Customer API Error:", error);
      setCustomers([]);
      setFilteredCustomers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;

    setSearch(value);

    const searchValue = value.toLowerCase().trim();

    if (!searchValue) {
      setFilteredCustomers(customers);
      return;
    }

    const filtered = customers.filter((item) =>
      `${item?.accountName || ""} 
       ${item?.mobile || ""} 
       ${item?.email || ""} 
       ${item?.city || ""} 
       ${item?.state || ""}`
        .toLowerCase()
        .includes(searchValue)
    );

    setFilteredCustomers(filtered);
  };

  // DataTable columns
  const columns = [
    {
      name: "S.No.",
      selector: (row, index) => index + 1,
      width: "80px",
      center: true,
    },
    {
      name: "Customer",
      selector: (row) => row?.accountName || "-",
      sortable: true,
      grow: 2,
    },
    {
      name: "Mobile",
      selector: (row) => row?.mobile || "-",
      sortable: true,
      grow: 1,
    },
    {
      name: "Email",
      selector: (row) => row?.email || "-",
      sortable: true,
      grow: 2,
    },
  ];

  // Custom DataTable style
const customStyles = {
  headRow: {
    style: {
      minHeight: "35px",
      backgroundColor: "#f4f5f5",
      borderBottom: "1px solid rgb(222, 226, 230)",
      borderTop: "1px solid rgb(222, 226, 230)",
    },
  },

  headCells: {
    style: {
      padding: "10px 12px",
      fontSize: "13px",
      fontWeight: "600",
      color: "#333",
      borderRight: "1px solid rgb(222, 226, 230)",
    },
  },

  rows: {
    style: {
      minHeight: "35px",
      fontSize: "13px",
      color: "#333",
      borderBottom: "1px solid #f1f1f1",
    },
  },
};

  return (
    <section className="profile-section">
      <div className="container-fluid">
        <Row>
          {/* Sidebar */}
            <Sidebarmenu />
          {/* Content */}
          <Col lg={10} md={9}>


            <Breadcrumbdasbord
                title="Customers"
                items={[
                  {
                    label: "Customers",
                    path: "/account/customers",
                  }
                ]}
              />

            <div className="customer-wrapper">
              {/* Header */}
              <div className="customer-header">
                <div className="search-box">
                  <Search size={18} />

                  <Form.Control
                    type="text"
                    value={search}
                    onChange={handleSearch}
                    placeholder="Search..."
                    className="border-0 shadow-none"
                  />
                </div>
              </div>

              {/* DataTable */}
              <div className="table-card-box">
                <DataTable
                  columns={columns}
                  data={filteredCustomers}
                  customStyles={customStyles}
                  progressPending={loading}
                  progressComponent={
                    <div className="py-4 text-center">
                      <Spinner animation="border" />
                    </div>
                  }
                  noDataComponent={
                    <div className="py-4 text-center">
                      No Customers Found
                    </div>
                  }
                  pagination
                  paginationPerPage={10}
                  paginationRowsPerPageOptions={[10, 20, 50, 100]}
                  highlightOnHover
                  responsive
                  striped
                  persistTableHead
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default CustomerPage;